import { connect } from 'react-redux'
import { selectIsChatBootstrapped } from 'ducks/chat/selectors/bootstrap'
import { doChatBootstrap } from 'ducks/chat/actions/bootstrap'
import { doSyncRooms } from 'ducks/chat/actions/rooms'
import { selectUpdatingMatrixRoomIds } from 'ducks/chat/selectors/rooms'
import { selectIsMatrixClientAndUiReady } from 'ducks/chat/selectors/client'
import {
  selectAccountPreferenceChatEnabled,
  selectAccountChatRoomId,
  selectIsSocialEnabled,
} from 'selectors/app/selectAccountPreferences'
import {
  selectChatTitleName,
  selectChatTitleCount,
} from 'ducks/chat/selectors/title'
import {
  selectIsForbidden,
  selectIsSocialForbidden,
} from 'ducks/chat/selectors/permissions'
import router from './router'

export { routes, registerPageReducer } from './routes'

const select = state => ({
  updatingMatrixIds: selectUpdatingMatrixRoomIds(state),
  titleName: selectChatTitleName(state),
  titleCount: selectChatTitleCount(state),
  isChatEnabled: selectAccountPreferenceChatEnabled(state),
  isSocialEnabled: selectIsSocialEnabled(state),
  isBootstrapped: selectIsChatBootstrapped(state),
  accountChatRoomId: selectAccountChatRoomId(state),
  isMatrixReady: selectIsMatrixClientAndUiReady(state),
  isForbidden: selectIsForbidden(state),
  isSocialForbidden: selectIsSocialForbidden(state),
})

const perform = {
  bootstrapChat: doChatBootstrap,
  onRoomsUpdated: doSyncRooms,
}

export default connect(select, perform)(router)
